import { CsvErrorItem } from '@atom/types/error';

interface Props {
  error: CsvErrorItem;
}

const lowercaseFirstLetter = (str: string) =>
  str.charAt(0).toLowerCase() + str.slice(1);

const InventoryUploadError = ({ error }: Props) => {
  return (
    <li>
      {error.row > 0
        ? `Row ${error.row} Column "${error.column}" ${lowercaseFirstLetter(
            error.message,
          )}`
        : error.message}
    </li>
  );
};

export default InventoryUploadError;
